"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDataDomeInDOM = exports.dataDomeClientScript = exports.dataDomeAjaxListenerPathScript = void 0;
var dataDomeClientScript = function dataDomeClientScript(envKey) {
  return "!(function (a, b, c, d, e, f) {\n        a.ddjskey = e;\n        a.ddoptions = f || null;\n        var m = b.createElement(c),\n            n = b.getElementsByTagName(c)[0];\n        (m.async = 1), (m.src = d), n.parentNode.insertBefore(m, n);\n    })(\n        window,\n        document,\n        'script',\n        'https://js.datadome.co/tags.js',\n        '".concat(envKey, "'\n    );");
};
exports.dataDomeClientScript = dataDomeClientScript;
var dataDomeAjaxListenerPathScript = function dataDomeAjaxListenerPathScript() {
  return "window.ddCaptchaOptions = {\n        ajaxListenerPath: [\n            'notificationpp.blackhawknetwork.com',\n            'notification.blackhawknetwork.com',\n        ],\n        allowHtmlContentTypeOnCaptcha: true,\n        withCredentials: false,\n        sessionByHeader: true,\n    }";
};
exports.dataDomeAjaxListenerPathScript = dataDomeAjaxListenerPathScript;
var renderDataDomeInDOM = function renderDataDomeInDOM(domScript, scriptId, type, scriptLocation) {
  if (!document.getElementById(scriptId)) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      if (type == 'text') {
        script.text = domScript;
      } else {
        script.src = domScript;
      }
      script.type = 'text/javascript';
      script.defer = true;
      script.setAttribute('id', scriptId);
      script.addEventListener('load', function () {
        resolve();
      });
      script.addEventListener('error', function (e) {
        reject(e);
      });
      if (scriptLocation == 'body') {
        document.body.appendChild(script);
      } else {
        document.head.appendChild(script);
      }
    });
  } else {
    return new Promise(function (resolve, _reject) {
      resolve(document.getElementById(scriptId));
    });
  }
};
exports.renderDataDomeInDOM = renderDataDomeInDOM;